export const NO_REPLY_EMAIL_ADDRESS = 'noreply@dealbinder.com';
export const INFO_EMAIL_ADDRESS = 'info@dealbinder.com';
export const STAGING = 'STAGING';

export const APPROVED = 'approved';
export const PENDING = 'pending';
export const UNRECOGNIZED = 'unrecognized';
